module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuMTJDBGvsAAAAi0lEQVRoQ+3PoQ0AMQwEwe+/aT8JHBxlo1gasuj8zUwaYwljCWMJYwljCWMJYwljCWMJYwljCeNy2mnje2DnaePdDyQwljCWMJYwljCWMC6nnTa+B3aeNt79QAJjCWMJYwljCWMJ43LaaeN7YOdp490PJDCWMJYwljCWMJYwljCWMJYwljCWMHbM9wPOppT15Rim7QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/content/img/hamburger.png
// module id = 1477
// module chunks = 0